export default {
  "actionConfiguration.body": [
    "actionConfiguration.pluginSpecifiedTemplates[0].value",
  ],
};
